<template>
  <multiselect
    v-model="selected"
    :options="options"
    placeholder=""
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    @input="onChange"
    label="nome"
    track-by="id"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'alreadySelected',
    'nameField',
    'localidadeSelected',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'tipo_metodo_pagamento', null);
        return;
      }
      this.$emit('selectChange', 'tipo_metodo_pagamento', e);
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option.id === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option.id === null);
        selectedActual = this.options.find((option) => option.id === null);
      }
      this.onChange(selectedActual);
      this.$emit('input', this.selected);
    },
    setOptions(localidadeId) {
      this.isLoading = true;
      this.$atenaList
        .getMetodosPagamento({
          columns: 'id as id_metodo_pagamento_site',
          related: 'tipo_metodo_pagamento:nome AS nome,id AS id',
          filter: ` metodo_pagamento_site.ativo IS true AND localidade_web.id_localidade in (${JSON.parse(
            localidadeId.id_localidades
          ).toString()})`,
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.$props.localidadeSelected);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },

  watch: {
    localidadeSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    if (this.localidadeSelected) this.setOptions(this.localidadeSelected);
  }
};
</script>

<style lang="scss" scoped></style>
